import * as React from 'react';
export const IcMoneyRequest = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 11a5 5 0 01-4.9-6H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-6a5 5 0 01-3 1zm-8 0a3.001 3.001 0 01-1.11 2.33l1.56.78A1 1 0 0111 16a.929.929 0 01-.45-.11l-4-2A1 1 0 017 12h1a1 1 0 100-2H6a1 1 0 110-2h5a1 1 0 110 2h-.18a3 3 0 01.18 1zm5.29-4.29l2 2a1.004 1.004 0 001.42-1.42l-.3-.29H21a1 1 0 100-2h-1.59l.3-.29a1.001 1.001 0 00-1.094-1.636 1 1 0 00-.326.216l-2 2a1 1 0 00-.21.33.92.92 0 000 .76 1 1 0 00.21.33z'
      fill='currentColor'
    />
  </svg>
);
